import SourceClient from 'sources/sourceTypes/Client';
import Client from 'types/Client';

export const toSource = (_obj: Client): SourceClient => {
  return new SourceClient();
};

export const toType = (sourceObj: SourceClient): Client => {
  const client = new Client();

  client.id = sourceObj.id;
  client.firstName = sourceObj.first_name;
  client.lastName = sourceObj.last_name;

  client.profileImage = sourceObj.profile_image;

  return client;
};
